import { handle400Statuses, sendApiRequest } from './api';
import { logNetRequest } from '@utils/usefulFuncs';

const BASE_URL = 'v1/genai/doc_upload_triggers';

export async function listTriggers() {
  const url = BASE_URL;
  const { status, data, error } = await sendApiRequest('get', url);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  if (status === 200 && data?.triggers) {
    return { triggers: data.triggers };
  }
  return { triggers: [], error: data?.error || error };
}

export async function createTrigger(payload) {
  const { status, data, error } = await sendApiRequest('post', BASE_URL, payload);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  if (status === 200) {
    return { trigger: data, error: null };
  }
  return { trigger: null, error: data?.error || error };
}

export async function deleteTrigger(id) {
  const url = `${BASE_URL}/${id}`;
  const { status, data, error } = await sendApiRequest('delete', url);
  logNetRequest(status, data, error);
  handle400Statuses(status);
  if (status === 200) {
    return { success: true, error: null };
  }
  return { success: false, error: data?.error || error };
}
